/**
 * @generated SignedSource<<397be6216a6413a628e021f13666809d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FirstBookingStatus = "confirmed" | "created" | "declined" | "%future added value";
export type fetchSingleContractQuery$variables = {
  contractId: string;
};
export type fetchSingleContractQuery$data = {
  readonly contract: {
    readonly id: string;
    readonly hasFulfilledBooking: boolean;
    readonly cancelationScheduledFor: string | null;
    readonly firstBookingStatus: FirstBookingStatus;
    readonly firstBookingConfirmationStatus: {
      readonly reason: string;
    } | null;
  } | null;
};
export type fetchSingleContractQuery = {
  variables: fetchSingleContractQuery$variables;
  response: fetchSingleContractQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      }
    ],
    "concreteType": "Contract",
    "kind": "LinkedField",
    "name": "contract",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasFulfilledBooking",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancelationScheduledFor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstBookingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "firstBookingConfirmationStatus",
        "kind": "LinkedField",
        "name": "firstBookingConfirmationStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchSingleContractQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchSingleContractQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c388eec08de31adc97e1d75693fee88e",
    "id": null,
    "metadata": {},
    "name": "fetchSingleContractQuery",
    "operationKind": "query",
    "text": "query fetchSingleContractQuery(\n  $contractId: ID!\n) {\n  contract(contractId: $contractId) {\n    id\n    hasFulfilledBooking\n    cancelationScheduledFor\n    firstBookingStatus\n    firstBookingConfirmationStatus {\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae9d02701888ea36f76dfe81f0b33bff";

export default node;
